<template>
  <v-app>
    <Header v-model="drawer"></Header>
    <Drawer v-model="drawer"></Drawer>
    <Confirm></Confirm>
    <v-main class="indigo lighten-5">
      <router-view></router-view>
      <Loader v-show="$root.loader"></Loader>
      <Message />
      <PregressLoader></PregressLoader>
      <Alert></Alert>
    </v-main>
    <div v-if="newVersionAvailable" class="update-banner">
      <div class="update-banner__content">
        <div>
          <div class="update-banner__title">New version available</div>
          <div class="update-banner__subtitle">Reload to get the latest version.</div>
        </div>
        <v-btn large depressed color="indigo darken-2" dark class="update-banner__btn" @click="reloadPage">
          Reload
        </v-btn>
      </div>
    </div>
  </v-app>
</template>
<script>
import Header from "./components/Header";
import Confirm from "./components/confirm/Confirm";
import Loader from "./components/Loader";
import PregressLoader from "./components/loader/Loader.vue";
import Alert from "./components/alert/Alert.vue";
import Message from "./components/Message";
import Drawer from "./components/Drawer";
import {
  auth,
  calculatedFields,
  carMake,
  carMakeUnlocking,
  cmp,
  dispositions,
  fieldOrders,
  firebase,
  firebaseConfig,
  globalFields,
  serviceFields,
  technicianGroups,
  technicians,
  smsTemplates,
  user,
  users,
  zipcodes,
  fieldConditions,
} from "./assets/js/firebase";
import "firebase/messaging";
import headers from "./assets/js/headers";
// import { exportJSON } from "./assets/js/common";

export default {
  name: "App",
  components: {
    Header,
    Confirm,
    Loader,
    PregressLoader,
    Alert,
    Message,
    Drawer,
  },
  data: () => ({
    drawer: window.innerWidth > 1200,
    newVersionAvailable: false,
  }),
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        let title = "EL CHEAPO - Jobs Management System";
        if (headers[to.name]) {
          title = `${headers[to.name]}`;
        }
        document.title = title;
      },
    },
  },
  computed: {
    isTemporary() {
      return window.innerWidth < 1200;
    },
  },
  methods: {
    initMessage() {
      if (firebase.messaging.isSupported()) {
        let messaging = firebase.messaging();
        messaging
          .getToken({
            vapidKey: firebaseConfig.vapidKey,
          })
          .then((token) => {
            if (token) {
              console.log(token);
              this.saveToken(token);
            }
          })
          .catch((err) => {
            console.warn("Notification permission not granted:", err.code || err.message);
          });
        messaging.onMessage((payload) => {
          console.log("Message received. ", payload);
          let { title, body, icon } = payload.notification;
          var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          console.log("status", document.hidden);
          if (isMobile) {
            navigator.serviceWorker.ready.then(function(registration) {
              registration.showNotification(title, {
                icon,
                body,
              });
            });
            /* your code here */
          } else {
            if (!document.hidden) {
              new Notification(title, {
                icon,
                body,
              });
            }
          }
        });
      }
    },
    saveToken(token) {
      let device_id = localStorage.device_id;
      console.log("device_id", device_id);
      if (!device_id) {
        let id = new Date().getTime().toString();
        console.log(id);
        localStorage.device_id = id;
        device_id = id;
      }
      let uid = auth.currentUser.uid;
      if (uid)
        user
          .child(uid)
          .child("tokens")
          .child(device_id)
          .set(token);
    },
    startVersionPolling() {
      // Version baked into this JS bundle at build time
      const bundleVersion = process.env.VUE_APP_BUILD_VERSION;

      // BroadcastChannel: one tab detects update → all open tabs get notified instantly
      if ("BroadcastChannel" in window) {
        this._versionChannel = new BroadcastChannel("app_version_update");
        this._versionChannel.onmessage = (e) => {
          // re-verify against server: this tab may already be on the latest bundle
          if (e.data === "new_version") {
            check();
          }
        };
      }

      const showBanner = () => {
        this.newVersionAvailable = true;
        if (this._versionChannel) {
          this._versionChannel.postMessage("new_version");
        }
      };

      const check = async () => {
        try {
          const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
          if (!res.ok) return;
          const { version } = await res.json();
          // If server version differs from what was baked into this bundle,
          // the SW served stale JS — show banner regardless of when tab was opened
          if (bundleVersion && version !== bundleVersion) {
            showBanner();
          }
        } catch (e) {
          // network error — ignore
        }
      };
      check();
      this._versionTimer = setInterval(check, 2 * 60 * 1000);
    },
    async reloadPage() {
      // delete all SW caches
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      }
      // unregister all service workers — next load fetches everything fresh from network
      if (navigator.serviceWorker) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((r) => r.unregister()));
      }
      window.location.reload();
    },
    init(uid) {
      const vm = this;
      vm.$store.dispatch("subscribeField");
      vm.$store.dispatch("listen", {
        store: "SET_GLOBLE_FIELDS",
        query: globalFields
          .orderBy("name", "asc")
          .where("type", "==", "global"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_REMOVED_FIELDS",
        query: globalFields.where("removed", "==", true),
      });
      vm.$store.dispatch("listen", {
        store: "SET_TECHNICIAN_GROUP",
        query: technicianGroups.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_ZIPCODES",
        query: zipcodes.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_CMP",
        query: cmp.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_FIELD_ORDERS",
        query: fieldOrders,
      });
      vm.$store.dispatch("listen", {
        store: "SET_SERVICE_FIELDS",
        query: serviceFields
          .orderBy("name", "asc")
          .where("type", "==", "service"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_FIELD_CONDITIONS",
        query: fieldConditions.orderBy("updatedAt", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_CALCULATED_FIELDS",
        query: calculatedFields.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_SMS_TEMPLATES",
        query: smsTemplates.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_MAKES",
        query: carMake.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_MAKES_UNLOCKING",
        query: carMakeUnlocking.orderBy("updated_at", "desc"),
      });
      vm.$store.dispatch("listen", {
        store: "SET_TECHNICIANS",
        query: technicians,
      });
      vm.$store.dispatch("listen", {
        store: "SET_DISPOSITIONS",
        query: dispositions.orderBy("name", "asc"),
      });
      vm.$store.dispatch("listenDoc", {
        store: "SET_USER",
        query: users.doc(uid),
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch("unSubscribeField");
    clearInterval(this._versionTimer);
    if (this._versionChannel) this._versionChannel.close();
  },
  mounted() {
    const vm = this;
    auth.onAuthStateChanged((user) => {
      if (user) {
        vm.init(user.uid);
        vm.initMessage();
      } else {
        vm.$store.dispatch("unSubscribeField");
      }
    });
    this.startVersionPolling();
  },
};
</script>
<style lang="scss">
.input_35 {
  .v-input__slot {
    min-height: 35px !important;
    input {
      padding-top: 15px;
    }
  }
  fieldset {
    height: 41px;
    margin-top: 2px;
  }
}
.v-text-field--outlined,
.v-text-field--solo {
  border-radius: 0px !important;
}
.v-text-field--solo {
  .v-input__control {
    border: thin solid rgba(0, 0, 0, 0.12);
  }
}
.v-dialog {
  border-radius: 0px !important;
}
.v-card {
  border-radius: 0px !important;
}
.custom__toolbar {
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    .title {
      color: black !important;
      padding-bottom: 10px;
    }
  }
}
.padding-10 {
  padding: 40px;
  @media only screen and (max-width: 600px) {
    padding: 10px !important;
  }
}
.padding-5 {
  padding: 20px;
  @media only screen and (max-width: 600px) {
    padding: 15px !important;
  }
}
.white-background {
  background: white;
  height: 100%;
}
.top-footer {
  border-top: 0px !important;
  @media only screen and (max-width: 600px) {
    display: none !important;
  }
}
.templates-table {
  th {
    background: #eeeeee;
    color: rgba(0, 0, 0, 0.7) !important;
    span {
      text-transform: uppercase !important;
    }
  }
  th {
    border-top: thin solid rgba(0, 0, 0, 0.12);
    i {
      display: none !important;
    }
  }
}
.v-list-item {
  border-radius: 0px !important;
}
.theme--light.v-tabs-items {
  background: transparent !important;
}
.flex-1 {
  flex: 1;
}
.no-col-padding {
  .c0l-sm-4,
  .col-12 {
    padding-top: 0px !important;
  }
}
.update-banner {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 9999;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.22);
  padding: 24px 28px;
  min-width: 380px;
  max-width: 460px;
  animation: slideUp 0.3s ease;
  @media only screen and (max-width: 600px) {
    left: 16px;
    right: 16px;
    bottom: 16px;
    min-width: unset;
  }
  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
  &__title {
    font-size: 17px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 6px;
  }
  &__subtitle {
    font-size: 14px;
    color: #555;
  }
  &__btn {
    flex-shrink: 0;
  }
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
